// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"beh_a bhc_bk bhc_bl bhc_bo","SwipeLeftToClose--animating":"beh_b"};